export class Quantity {
  private constructor(
    private readonly _value: number,
    private readonly _unit: string
  ) {
    if (_value < 0) {
      throw new Error('Quantity cannot be negative');
    }
  }

  static create(value: number, unit: string): Quantity {
    return new Quantity(value, unit);
  }

  static zero(unit: string): Quantity {
    return new Quantity(0, unit);
  }

  get value(): number {
    return this._value;
  }

  get unit(): string {
    return this._unit;
  }

  add(other: Quantity): Quantity {
    if (other.unit !== this.unit) {
      throw new Error('Cannot add quantities with different units');
    }
    return new Quantity(this.value + other.value, this.unit);
  }

  subtract(other: Quantity): Quantity {
    if (other.unit !== this.unit) {
      throw new Error('Cannot subtract quantities with different units');
    }
    const result = this.value - other.value;
    if (result < 0) {
      throw new Error('Quantity cannot be negative');
    }
    return new Quantity(result, this.unit);
  }

  multiply(multiplier: number): Quantity {
    return new Quantity(this.value * multiplier, this.unit);
  }

  equals(other: Quantity): boolean {
    return this.value === other.value && this.unit === other.unit;
  }

  toString(): string {
    return `${this.value} ${this.unit}`;
  }

  toJSON(): { value: number; unit: string } {
    return {
      value: this.value,
      unit: this.unit
    };
  }
}
